export default __webpack_public_path__ + "static/media/steph.png.webp";